import { Suspense, useContext } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { Loading } from "../components/Loading";
import {
	Budget,
	BudgetRegister,
	Company,
	Dashboard,
	ForgotPassword,
	NewPassword,
	SignIn,
	SystemSetup,
} from "./Pages";
import { AuthContext } from "contexts/authContext";
import { RequiredAuth } from "./Pages/RequiredAuth";

export function RoutesComponent() {
	const { token } = useContext(AuthContext);

	return (
		<Suspense fallback={<Loading />}>
			<Routes>
				<Route
					path="/"
					element={<Navigate to={token ? "/orcamento" : "/login"} />}
				/>

				<Route path="/login" element={<SignIn />} />
				<Route path="/forgotPassword" element={<ForgotPassword />} />
				<Route path="/newPassword" element={<NewPassword />} />
				<Route path="/register" element={<NewPassword />} />
				<Route path="/empresa" element={<Company />} />

				<Route
					path="/dashboard"
					element={
						<RequiredAuth>
							<Dashboard />
						</RequiredAuth>
					}
				/>

				<Route
					path="/orcamento"
					element={
						<RequiredAuth>
							<Budget />
						</RequiredAuth>
					}
				/>

				<Route
					path="/orcamento/cadastro"
					element={
						<RequiredAuth>
							<BudgetRegister />
						</RequiredAuth>
					}
				/>
				<Route
					path="/orcamento/cadastro/:id"
					element={
						<RequiredAuth>
							<BudgetRegister />
						</RequiredAuth>
					}
				/>
				<Route
					path="/sistema"
					element={
						<RequiredAuth>
							<SystemSetup />
						</RequiredAuth>
					}
				/>

				{/* TODO - criar rota 404 */}
				<Route
					path="*"
					element={
						<>
							<h1>404</h1>
						</>
					}
				/>
			</Routes>
		</Suspense>
	);
}
